import { classifyDeal } from "./dealHealth";
/**
 * dealFilters.js — SSOT deal-filter helpers used across the app.
 * ================================================================
 *
 * iter-alignment · P0 · Command Centre · Final Pilot QA
 * (2026-03-02) — Command Centre showed 16 "active" deals while
 * the sidebar's "N Active" chip showed 15.  Root cause: the two
 * surfaces derived "active" independently and the Command
 * Centre's filter (`TodayPage.activeDeals`) only excluded deals
 * whose `stage === "fallen_through"`, missing the canonical
 * `status ∈ {Completed, Fallen Through}` and `stage === "completed"`
 * terminal shapes.  This module is the single source of truth so
 * both surfaces answer the same question the same way.
 *
 * Rules (mirrors backend `get_active_deals`):
 *   • archived deals              → NOT active
 *   • status === "Completed"      → NOT active
 *   • status === "Fallen Through" → NOT active
 *   • stage  === "completed"      → NOT active
 *   • stage  === "fallen_through" → NOT active
 *
 * Everything else (Active / At Risk / Exchanged in-flight) counts.
 * Purely pure — takes a deal shape, returns a boolean, no
 * side-effects, no I/O.
 */

const _TERMINAL_STATUSES = new Set(["Completed", "Fallen Through"]);
const _TERMINAL_STAGES   = new Set(["completed", "fallen_through"]);

export function isActiveDeal(deal) {
  if (!deal || typeof deal !== "object") return false;
  if (deal.archived) return false;
  if (_TERMINAL_STATUSES.has(deal.status)) return false;
  const stage = String(deal.stage || "").toLowerCase();
  if (_TERMINAL_STAGES.has(stage)) return false;
  return true;
}

// Canonical "needs attention": live deal saved as At Risk, chain health below 70, or canonically
// At Risk (e.g. a pre-exchange deal past its exchange target).
export function needsAttentionDeal(deal) {
  if (!isActiveDeal(deal)) return false;
  return classifyDeal(deal).needsAttention;
}

export const _DEAL_FILTERS_TERMINAL_STATUSES = _TERMINAL_STATUSES;
export const _DEAL_FILTERS_TERMINAL_STAGES   = _TERMINAL_STAGES;
